import React from 'react';
interface WaveformVisualizerProps {
  color?: string;
  height?: number;
  bars?: number;
  animated?: boolean;
  className?: string;
}
export function WaveformVisualizer({
  color = '#00F0FF',
  height = 40,
  bars = 20,
  animated = true,
  className = ''
}: WaveformVisualizerProps) {
  return <div className={`flex items-center justify-center gap-[2px] ${className}`} style={{
    height: `${height}px`
  }} data-id="element-184">
      {Array.from({
      length: bars
    }).map((_, i) => {
      // Generate a somewhat random but symmetrical-ish pattern
      const center = bars / 2;
      const dist = Math.abs(i - center);
      const baseHeight = Math.max(20, 100 - dist * (100 / center));
      // Randomize slightly for organic look
      const randomHeight = Math.random() * 30;
      const finalHeight = Math.min(100, baseHeight + randomHeight);
      const animationDelay = i * 0.05;
      const animationDuration = 0.8 + Math.random() * 0.5;
      return <div key={i} className="w-1 rounded-full opacity-80" style={{
        backgroundColor: color,
        height: `${finalHeight}%`,
        animation: animated ? `pulse-height ${animationDuration}s ease-in-out infinite` : 'none',
        animationDelay: `-${animationDelay}s`
      }} data-id="element-185" />;
    })}
    </div>;
}